import * as React from "react";

function SvgIcons8WindowsXp(props, ref) {
  return (
    <svg viewBox="12 -12 48 48" width="1em" height="1em" {...{ ...props, ref }}>
      <path
        fill="#03a9f4"
        d="M34.807 12.511l-3.488 12.077c-3.03-2.052-6.327-3.744-13.318-.83l3.408-11.945.041-.019c6.964-2.886 10.337-1.347 13.357.717z"
      />
      <path
        fill="#ffc107"
        d="M36.633 13.68l-3.447 11.943c3.028 2.069 6.383 3.718 13.365.805l3.324-11.643c-7.115 2.455-10.215.946-13.242-1.105z"
      />
      <path
        fill="#ff5722"
        d="M35.387 10.337l3.441-11.964c-3.028-2.061-6.386-3.717-13.374-.797L22.011 9.59c2.775-1.153 4.969-1.682 6.806-1.666 2.787.018 4.746 1.178 6.57 2.413z"
      />
      <path
        fill="#7cb342"
        d="M40.643-.369l-3.44 12.033c3.018 2.063 6.669 3.752 13.359.738L54 .415c-6.979 2.902-10.335 1.273-13.357-.784z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8WindowsXp);
